import { trpc } from '@tencent/tpro_rmonitor_login_server_login_auth';
import IUserInfo = trpc.rmonitor.login_server.IUserInfo;

export interface Token {
  saasToken: string;
  uin: string;
  ownerUin: string;
  buglyToken: string;
}

export interface AuthInfo {
  isLoggedIn: boolean;
  token?: string;
  saasToken?: string;
  userInfo?: IUserInfo | null;
}

export const BUGLY_LOGIN_STORAGE_KEY = 'bugly_user_auth_info';

export const BUGLY_LAST_LOGIN = 'bugly_last_login';

export const TDS_TOKEN = 'tds_token';

export const TDS_SASS_UIN = 'tds_sass_uin';

export const TDS_SASS_TOKEN = 'tds_sass_token';

export const TDS_USER_ID = 'tds_uid';

export const TDS_USER_NAME = 'tds_username';

export enum LoginType {
  IOA = 'ioa',
  TencentCloud = 'tencent_cloud'
}

export enum TencentCloudLoginType {
  Wechat = 'wechat',
  QQ = 'qq'
}

export enum SubSystemType {
  SubAccount = 'SubAccount',
}

export type TencentCloudAccountOwnerInfo = {
  account: string;
  checkStatus: string | null;
  displayName: string;
  email: string;
  emailFlag: number;
  isDefaultOwner: boolean;
  phone: string;
  phoneFlag: number;
  subSystemType: SubSystemType;
  subUserName: string;
  uin: string;
  userName: string;
  extAttr: {
    needResetStoken: boolean;
    needResetToken: boolean;
  }
};

